import {Text} from './Text';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { trim } from 'lodash';
import React, { useEffect, useState } from 'react';
import { themeDefault } from 'src/theme-revamp';
import Button from '@components/_Revamp/Button';
import NameSelectorItem from './NameSelectorItem';
import {NameSelectorItemProps} from '@utils/helpers'
import warningIcon from '@assets/icon/alert-circle-red.svg'

const Container = styled.div`
  display: block;
  background-color: #ffffff;
`;

const UpperContainer = styled.div`
  display: block;
  flex-direction: column;
`;

const MainTitleContainer = styled.div`
  display: block;
  flex-direction: column;
  margin-bottom: 16px;
  &>div {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    gap:12px;
    margin-top: 16px;
  }
`;

const DescriptionContainer = styled.div`
  display: block;
  flex-direction: column;
  margin-bottom: 13px;
`;

const ErrorMessageContainer = styled.div`
  height: 80px;
  position: relative;
  @media screen and (min-width: 768px) {
    height: 100px;
  }
`;

const InnerErrorMessageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 23px;
`;

const BottomContainer = styled.div<BottomNameContainerProps>`
  display: flex;
  flex-wrap: no-wrap;
  justify-content: flex-start;
  overflow-x: scroll;
  padding: ${props => props.padding ? props.padding : "0"};
  margin: ${props => props.margin ? props.margin : "unset"};
  @media screen and (min-width: 768px) {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  &::-webkit-scrollbar { 
    display: none;
  }
`;

const ActionContainer = styled.div`
  display: flex;
  align-items:center;
  justify-content: center;
  flex-direction:column;
  row-gap: 8px;
  margin-top: 50px;
  @media screen and (min-width: 768px) {
    flex-direction:row;
    column-gap: 24px;
    margin-top: 48px;
  }
`;

const TitleContainer = styled.div`
  display: block;
`;

const TitleInputContainer = styled.div<BottomNameContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60px;
  flex-wrap: no-wrap;
  overflow-x: scroll;
  margin: ${props => props.margin ? props.margin : "unset"};
  padding: ${props => props.padding ? props.padding : "0"};
  @media screen and (min-width: 768px) {
    flex-wrap: wrap;
  }
  &::-webkit-scrollbar { 
    display: none;
  }
`;

const UnderlineSeperator = styled.div<BottomNameContainerProps>`
  background-color: ${props => props.bg ? props.bg : " #c4c4c4"};
  height:1px;
  width: 100%;
  margin: 0 0 16px;
`;

const TitleClass = css`
  display: block;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #8a8988;
  text-transform: capitalize;
`;

const MainTitleClass = css`
  display: block;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  color: #434343;
  @media screen and (min-width: 768px) {
    font-size: 28px;
    padding:0 20px;
  }
`;

const DescriptionClass = css`
  display: block;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #8a8988;
`;

const ErrorMessageClass = css`
  display: block;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #434343;
`;

interface BottomNameContainerProps{
  margin?: string;
  padding?: string;
  bg?: string;
}

export interface NameSelectorProps {
  headerTitle: string;
  selectorItems: NameSelectorItemProps[];
  visibility: boolean;
  onChange?: (e: any) => void;
  onCancelClick?: () => void;
  onSaveClick?: (e: any) => void;
  margin?: string;
  padding?: string;
  nameSelectsFor?: string
}


function NameSelector({
  headerTitle,
  selectorItems,
  onChange,
  onSaveClick,
  onCancelClick,
  visibility,
  margin,
  padding,
  nameSelectsFor
}: NameSelectorProps) {
  const [nameLabelItems, setNameLabelItems] = useState<NameSelectorItemProps[]>([]);
  const [nameSelectedItems, setnameSelectedItems] = useState<NameSelectorItemProps[]>([]);
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  const unselectItemProcess = async (e: NameSelectorItemProps) => {
    let unselectedNameItemsIndex = nameSelectedItems.findIndex(
      (ele) => ele.id === e.id
    );
    let unselectedNameLabelIndex = nameLabelItems.findIndex(
      (ele) => ele.id === e.id
    );

    setNameLabelItems((prev) => {
      let temp = prev;
      temp[unselectedNameLabelIndex].selected = false;
      return [...temp];
    });
    nameSelectedItems.splice(unselectedNameItemsIndex, 1);
    setnameSelectedItems([...nameSelectedItems]);
  };

  const selectItemProcess = (e: NameSelectorItemProps, index: number) => {
    setNameLabelItems((prev) => {
      let temp = prev;
      temp[index].selected = true;
      return [...temp];
    });
    setnameSelectedItems((prev) => {
      let temp = prev;
      let indexOfExisted = temp.findIndex((ele) => ele.id === e.id);
      if (indexOfExisted === -1) {
        temp.push(e);
      }
      return [...temp];
    });
  };

  useEffect(() => {
    if (isFirst) {
      
      setNameLabelItems(selectorItems);
      setIsFirst(false);
      // let selectedDefaultindex = selectorItems.findIndex(e=>e.selected === true);
      selectorItems.forEach((e) => {
        if (e.selected) {
          setnameSelectedItems((prev) => {
            let temp = prev;
            let indexOfExisted = temp.findIndex((ele) => ele.id === e.id);
            if (indexOfExisted === -1) {
              temp.push(e);
            }
            temp = temp.sort((a,b)=>a.order-b.order)
            return [...temp];
          });
        }
      });
    }
  }, [isFirst, selectorItems]);

  useEffect(() => {
    if (nameSelectedItems.length <= 0 || nameSelectedItems.length === nameLabelItems.length) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [nameLabelItems, nameSelectedItems]);
  useEffect(() => {
    setnameSelectedItems([]);
    setNameLabelItems(selectorItems);
    selectorItems.forEach((e) => {
      if (e.selected) {
        setnameSelectedItems((prev) => {
          let temp = prev;
          let indexOfExisted = temp.findIndex((ele) => ele.id === e.id);
          if (indexOfExisted === -1) {
            temp.push(e);
          }
          temp.sort((a, b) => a.order - b.order);
          return [...temp];
        });
      }
    });
    console.log('selectorItems',selectorItems);
  }, [selectorItems, visibility]);

  const saveProcess = () => {
    let resultString = '';
    nameSelectedItems.forEach((e) => {
      resultString += e.title + ' ';
    });
    if (onSaveClick) {
      console.log('resultString', trim(resultString));
      // onSaveClick(trim(resultString));
      onSaveClick({name:trim(resultString), nameItems: nameSelectedItems})
    }
  };
  return (
    <Container>
      <MainTitleContainer>
        <Text variant="base" textClass={MainTitleClass} align={'center'}>
          Select your {headerTitle}.
        </Text>
        {nameSelectedItems.length === nameLabelItems.length &&<div><img src={warningIcon} alt="warning icon" />
                <span>Select the correct last/family name.</span></div>}
      </MainTitleContainer>
      { nameSelectsFor === "shieldStartter" ? <div style={{marginBottom: "64px"}}></div> :
        <DescriptionContainer>
          <Text variant="base" textClass={DescriptionClass} align={'center'}>
            To remove selection click on it in the text field
          </Text>
        </DescriptionContainer>
      }
      { nameSelectsFor === "shieldStartter" ? null :
      <ErrorMessageContainer>
        {(nameSelectedItems.length <= 0 || nameSelectedItems.length === nameLabelItems.length) && (
          <InnerErrorMessageContainer>
            <IconContainer>
              <svg
                width='19'
                height='18'
                viewBox='0 0 19 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M9.5 16.5C13.6421 16.5 17 13.1421 17 9C17 4.85786 13.6421 1.5 9.5 1.5C5.35786 1.5 2 4.85786 2 9C2 13.1421 5.35786 16.5 9.5 16.5ZM9.5 18C14.4706 18 18.5 13.9706 18.5 9C18.5 4.02944 14.4706 0 9.5 0C4.52944 0 0.5 4.02944 0.5 9C0.5 13.9706 4.52944 18 9.5 18Z'
                  fill='#C50000'
                />
                <path
                  d='M9.89373 11.6255L10.2125 5.24906C10.2329 4.84156 9.90801 4.5 9.5 4.5C9.09199 4.5 8.76708 4.84156 8.78745 5.24906L9.10627 11.6255C9.11676 11.8353 9.28993 12 9.5 12C9.71007 12 9.88324 11.8353 9.89373 11.6255Z'
                  fill='#C50000'
                />
                <circle cx='9.5' cy='13.5' r='0.75' fill='#C50000' />
              </svg>
            </IconContainer>
            <Text variant="base" textClass={ErrorMessageClass} align={'center'}>
              {nameSelectedItems.length <= 0 && 'The field cannot be empty'}
             
            </Text>
          </InnerErrorMessageContainer>
        )}
      </ErrorMessageContainer>
      }

      <UpperContainer>
        <TitleContainer>
          <Text variant="base" textClass={TitleClass} align={'left'}>
            {headerTitle}
          </Text>
        </TitleContainer>
        <TitleInputContainer padding={padding} margin={margin}>
          {nameSelectedItems.map((e, index) => {
            return (
              <NameSelectorItem
                key={index}
                onClick={() => unselectItemProcess(e)}
                title={e.title}
                variant={'selected'}
                selected
                nsFor={nameSelectsFor}
              />
            );
          })}
        </TitleInputContainer>
        <div></div>
      </UpperContainer>
      
      {nameSelectsFor === "shieldStartter" && (nameSelectedItems.length <= 0 || nameSelectedItems.length === nameLabelItems.length) ? (
        <>
          <UnderlineSeperator ></UnderlineSeperator>
          {/* <Text variant="base" margin='0 0 10px 0' color='#C50000' align={'left'}> */}
            {/* {nameSelectedItems.length <= 0 && 'The field cannot be empty'} */}
            {/* {nameSelectedItems.length === nameLabelItems.length &&
              ('Please select a valid ' + headerTitle)} */}
          {/* </Text> */}
        </>
      ) : <UnderlineSeperator></UnderlineSeperator>}
      <BottomContainer padding={padding} margin={margin}>
        {nameLabelItems.map((e, index) => {
          return (
            <NameSelectorItem
              key={index}
              onClick={() => selectItemProcess(e, index)}
              title={e.title}
              variant={'default'}
              selected={e.selected}
              nsFor={nameSelectsFor}
            />
          );
        })}
      </BottomContainer>

      <ActionContainer>
        { nameSelectsFor === "shieldStartter" ? null :
        <Button
          variant={'secondary'}
          theme={themeDefault}
          onClick={onCancelClick}
          label={'Cancel'}
          width={'180px'}
          margin={0}
        />
        }
        <Button
          variant={'default'}
          theme={themeDefault}
          disabled={isError}
          onClick={saveProcess}
          label={nameSelectsFor === "shieldStartter" ? "Confirm" : 'Save'}
          width={'180px'}
          margin={0}
        />
      </ActionContainer>
    </Container>
  );
}

export default NameSelector;
